import {
  Overlay,
  OverlayPositionBuilder,
  OverlayRef,
} from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import {
  ComponentRef,
  Directive,
  HostListener,
  Input,
  inject,
} from '@angular/core';

import { CustomTooltipComponent } from '../components/custom-tooltip.component';

@Directive({ selector: '[appCustomTooltip]', standalone: false })
export class CustomTooltipDirective {
  private overlay = inject(Overlay);
  private overlayPositionBuilder = inject(OverlayPositionBuilder);

  @Input('appCustomTooltip') imageUrl = '';
  private overlayRef?: OverlayRef;

  @HostListener('mousemove', ['$event'])
  show(ev: MouseEvent): void {
    if (!this.overlayRef) {
      const positionStrategy = this.overlayPositionBuilder
        .global()
        .left(ev.clientX + 20 + 'px')
        .top(ev.clientY + 10 + 'px');

      this.overlayRef = this.overlay.create({ positionStrategy });

      const tooltipRef: ComponentRef<CustomTooltipComponent> =
        this.overlayRef!.attach(new ComponentPortal(CustomTooltipComponent));

      tooltipRef.instance.imageUrl = this.imageUrl;
    } else {
      this.overlayRef.updatePositionStrategy(
        this.overlayPositionBuilder
          .global()
          .left(ev.clientX + 20 + 'px')
          .top(ev.clientY + 10 + 'px'),
      );
    }
  }

  @HostListener('mouseout')
  hide(): void {
    this.overlayRef!.detach();
    this.overlayRef = undefined;
  }
}
